import { render, staticRenderFns } from "./AMenu.vue?vue&type=template&id=fdd9655c&scoped=true"
import script from "./AMenu.vue?vue&type=script&lang=ts"
export * from "./AMenu.vue?vue&type=script&lang=ts"
import style0 from "./AMenu.vue?vue&type=style&index=0&id=fdd9655c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd9655c",
  null
  
)

export default component.exports